import React, { useState } from "react";
import { Mail, Phone, Instagram, Menu, X } from "lucide-react";

const Header = () => {
    const [open, setOpen] = useState(false);

    return (
        <header className="w-full">
            {/* Üst Bilgi Barı */}
            <div className="bg-[#454a55] text-white text-sm flex flex-col md:flex-row justify-center md:justify-end items-end gap-2 md:gap-4 py-3 px-4 md:px-32 text-center">
                {/* Mail */}
                <div className="flex items-center justify-center gap-2">
                    <Mail size={16} />
                    <a href="mailto:info@kahramanahsapmerdiven.com" className="hover:underline">
                        info@kahramanahsapmerdiven.com
                    </a>
                </div>
                {/* Telefon */}
                <div className="flex items-center justify-center gap-2">
                    <Phone size={16} />
                    <a href="tel:+905327486768" className="hover:underline">
                        +90 532 748 67 68
                    </a>
                </div>

                {/* Instagram */}
                <div className="flex items-center justify-center gap-2 cursor-pointer">
                    <Instagram size={20} />
                </div>
            </div>


            {/* Alt Menü */}
            <div className="bg-[#81858e] flex items-center justify-between px-4 md:px-32 py-3 relative">
                {/* Logo */}
                <div className="flex items-center">
                    <img
                        src="/logo.png"
                        alt="Kahraman Ahşap Merdiven"
                        className="h-16 w-16 rounded-full object-cover"
                    />
                </div>

                {/* Menü - Desktop */}
                <nav className="hidden md:block text-sm">
                    <ul className="flex items-center gap-10 text-white font-semibold tracking-wide">
                        <li>
                            <a href="#hakkimizda" className="hover:text-gray-300 ">
                                HAKKIMIZDA
                            </a>
                        </li>
                        <li>
                            <a href="#galeri" className="hover:text-gray-300">
                                GALERİ
                            </a>
                        </li>
                        <li>
                            <a href="#referanslar" className="hover:text-gray-300">
                                REFERANSLAR
                            </a>
                        </li>
                        <li>
                            <a href="#iletisim" className="hover:text-gray-300">
                                İLETİŞİM
                            </a>
                        </li>
                    </ul>
                </nav>

                {/* Hamburger Butonu - Mobile */}
                <button
                    onClick={() => setOpen(!open)}
                    className="md:hidden border border-black rounded-full p-2 text-white font-extrabold"
                >
                    {open ? <X size={20} /> : <Menu size={20} />}
                </button>

                {/* Açılır Menü - Mobile */}
                {open && (
                    <div className="absolute top-full left-0 w-full bg-[#81858e] text-white text-center flex flex-col gap-4 py-5 shadow-md z-50">
                        <a href="#hakkimizda" onClick={() => setOpen(false)}>
                            HAKKIMIZDA
                        </a>
                        <a href="#galeri" onClick={() => setOpen(false)}>
                            GALERİ
                        </a>
                        <a href="#referanslar" onClick={() => setOpen(false)}>
                            REFERANSLAR
                        </a>
                        <a href="#iletisim" onClick={() => setOpen(false)}>
                            İLETİŞİM
                        </a>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
